import { FloatingFocusManager, FloatingPortal } from '@floating-ui/react'
import classNames from 'classnames'

import { useScreen } from '../../../../hooks'
import { getQaSelector } from '../../../../utils/common'
import { stopPropagation } from '../../../../utils/events'
import Button from '../../../Button'

import {
  QA_NAME_MATCH_CRITERIA_POPOVER,
  QA_NAME_MATCH_CRITERIA_POPOVER_TRIGGER,
} from './RentalPortalMatchCriteriaPopover.constants'
import { useRentalPortalMatchCriteriaPopover } from './RentalPortalMatchCriteriaPopover.hooks'
import { getIsMatchCriteriaPopoverSheet } from './RentalPortalMatchCriteriaPopover.utils'
import { RentalPortalMatchCriteriaPopoverCriteria } from './RentalPortalMatchCriteriaPopoverCriteria'
import { RentalPortalMatchCriteriaPopoverHeader } from './RentalPortalMatchCriteriaPopoverHeader'

import * as styles from './RentalPortalMatchCriteriaPopover.module.css'

function RentalPortalMatchCriteriaPopover({
  children,
  className = styles.trigger,
  match,
}) {
  const { width } = useScreen()

  const {
    context,
    floatingStyles,
    getFloatingProps,
    getReferenceProps,
    isOpen,
    setFloating,
    setReference,
  } = useRentalPortalMatchCriteriaPopover()

  const isSheet = getIsMatchCriteriaPopoverSheet(width)

  return (
    <>
      <Button.Text
        {...getReferenceProps({
          onClick: stopPropagation,
          onMouseDown: stopPropagation,
        })}
        className={className}
        elementRef={setReference}
        qaName={QA_NAME_MATCH_CRITERIA_POPOVER_TRIGGER}
      >
        {children}
      </Button.Text>
      {isOpen ? (
        <FloatingPortal>
          <FloatingFocusManager returnFocus context={context} modal={false}>
            <div
              {...getFloatingProps()}
              {...getQaSelector({ value: QA_NAME_MATCH_CRITERIA_POPOVER })}
              className={classNames(styles.RentalPortalMatchCriteriaPopover, {
                [styles.sheet]: isSheet,
              })}
              ref={setFloating}
              style={isSheet ? undefined : floatingStyles}
            >
              <RentalPortalMatchCriteriaPopoverHeader match={match} />
              <RentalPortalMatchCriteriaPopoverCriteria match={match} />
            </div>
          </FloatingFocusManager>
        </FloatingPortal>
      ) : null}
    </>
  )
}

export default RentalPortalMatchCriteriaPopover
